import { defineMessages } from 'react-intl';

export default defineMessages({
  intl: {
    defaultMessage: 'Intl',
    id: 'app.links.intl'
  },
  fields: {
    defaultMessage: 'Fields',
    id: 'app.links.fields'
  },
  firebase: {
    defaultMessage: 'Login',
    id: 'app.links.firebase'
  },
  movies: {
    defaultMessage: 'Add Movies',
    id: 'app.links.movies'
  },
  selection: {
    defaultMessage: 'Pick One',
    id: 'app.links.selection'
  },
  home: {
    defaultMessage: 'Home',
    id: 'app.links.home'
  },
  login: {
    defaultMessage: 'Login',
    id: 'app.links.login'
  },
  me: {
    defaultMessage: 'Me',
    id: 'app.links.me'
  },
  todos: {
    defaultMessage: 'Todos',
    id: 'app.links.todos'
  },
  offline: {
    defaultMessage: 'Offline',
    id: 'app.links.offline'
  },
});



// WEBPACK FOOTER //
// ./src/common/app/linksMessages.js